import { combineReducers } from 'redux'
import _ from 'lodash'

import * as healthSelectedServicesList from './list'
import * as getHealthSelectedService from './get'
import * as createHealthSelectedService from './create'
import * as editHealthSelectedService from './edit'
import * as deleteHealthSelectedService from './delete'

const slices = {
  healthSelectedServicesList,
  getHealthSelectedService,
  createHealthSelectedService,
  editHealthSelectedService,
  deleteHealthSelectedService
}

const healthSelectedServiceTypes = _.mapValues(slices, (s) => s.slice.types)
const healthSelectedServiceActions = Object.assign({}, ..._(slices).values().map('slice.actions').value())
const healthSelectedServiceSagas = _(slices).values().map('slice.sagas').flatten().value()
const healthSelectedServiceSelectors = Object.assign({}, ..._(slices).values().map('slice.selectors').value())
const reducers = Object.assign({}, ..._(slices).values().map('default').value())

export { healthSelectedServiceTypes, healthSelectedServiceActions, healthSelectedServiceSagas, healthSelectedServiceSelectors }

export default combineReducers(reducers)
